export default "__VITE_ASSET__CVNO47Ap__"